import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Ajmal from "../../assets/area/Ajmal.jpg";
import Hawa from "../../assets/area/Hawa.jpg";
import Shoumous from "../../assets/area/Shoumous.jpg";
import Tiger from "../../assets/area/Tiger.jpg";

const lifestyleData = [
  {
    title: "Tiger Ajman Downtown",
    subtitle: "Urban high-rise living in Ajman city center.",
    image: Tiger,
  },
  {
    title: "Shoumous",
    subtitle: "Affordable and modern residential development in Sharjah.",
    image: Shoumous,
  },
  {
    title: "Ajmal Makan – Sharjah Waterfront",
    subtitle: "Island-style waterfront city with villas and apartments.",
    image: Ajmal,
  },
  {
    title: "Hawa Residence",
    subtitle: "Modern residential project with premium finishing.",
    image: Hawa,
  },
];

export default function LifestyleSection() {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        py: { xs: 4, md: 4 },
        position: "relative",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          textAlign: "center",
          mb: { xs: 2, md: 2 },
          px: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 28, md: 40 },
            fontWeight: 600,
            letterSpacing: "-0.02em",
            color: "var(--color-text-primary)",
          }}
        >
          Life
          <Box component="span" sx={{ color: "var(--color-gold)" }}>
            style
          </Box>
        </Typography>

        <Typography
          sx={{
            maxWidth: 520,
            mx: "auto",
            fontSize: 15,
            color: "var(--color-text-muted)",
            lineHeight: 1.7,
          }}
        >
          Explore a diverse array of options tailored to suit any lifestyle.
          Choose with confidence alongside us.
        </Typography>
      </Box>
      {/* COLLAGE */}
      <Box
        sx={{
          display: "flex",
          height: { xs: 420, md: 520 },
          overflowX: { xs: "auto", md: "hidden" },
          scrollSnapType: { xs: "x mandatory", md: "none" },
        }}
      >
        {lifestyleData.map((item, index) => (
          <LifestyleCard key={index} item={item} />
        ))}
      </Box>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}

/* ------------------------------------------------------------------ */
/* CARD */
/* ------------------------------------------------------------------ */

function LifestyleCard({ item }) {
  return (
    <Box
      component={motion.div}
      layout
      whileHover={{ flex: 1.6 }}
      // transition={{ duration: 0.5, ease: "easeOut" }}
      transition={{
        type: "spring",
        stiffness: 200,
        damping: 24,
      }}
      sx={{
        position: "relative",
        flex: 1,
        minWidth: { xs: "85%", md: "auto" },
        height: "100%",
        overflow: "hidden",
        scrollSnapAlign: "start",
        cursor: "pointer",
        "&:hover .overlay": {
          opacity: 1,
        },
      }}
    >
      {/* IMAGE */}
      <Box
        component="img"
        src={item.image}
        alt={item.title}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transition: "transform 0.6s ease",
        }}
      />

      {/* OVERLAY */}
      <Box
        className="overlay"
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.55))",
          opacity: 0,
          transition: "opacity 0.4s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 3,
          // "&:hover": {
          //   opacity: 1,
          // },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#fff",
              mb: 1,
            }}
          >
            {item.title}
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "rgba(255,255,255,0.9)",
              lineHeight: 1.6,
            }}
          >
            {item.subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
